import { GENDER, GENDER_VARIABLE_FROM_COOKIE, GenderCodeType } from '@monorepo/constants';
import { getCookie, setCookie } from '@monorepo/utils';

const GENDER_LIST = Object.entries(GENDER).map((g) => g[1].code);

export const cookieGender = () => {
  const genderFromCookie = getCookie<GenderCodeType>(GENDER_VARIABLE_FROM_COOKIE);
  if (!GENDER_LIST.includes(genderFromCookie)) {
    setCookie(GENDER_VARIABLE_FROM_COOKIE, GENDER.A.code, 365);
    return GENDER.A.code;
  }
  return genderFromCookie;
};
